export default __webpack_public_path__ + "static/media/dark-personal-portfolio-landing.d033d8e3.png";